import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
  }

  show() {
    this.modalTarget.appendChild(document.querySelector("#header"));
    this.modalTarget.showModal();

    window.dispatchEvent(new CustomEvent("menuOpened"));
  }

  closeFromBackdrop(e) {
    if (e.type == "mousedown" && e.target == this.modalTarget) {
      this.close();
    }
  }

  cancel(e) {
    this.close();
  }

  close(e) {
    document.body.querySelector("#header").querySelectorAll(
      ".open:not(.main)",
    ).forEach(
      (element) => element.classList.remove("open"),
    );
    this.modalTarget.close();

    document.body.prepend(document.querySelector("#header"));

    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("menuClosed"));
    }, 1);
  }
}
